import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "total-count" };
const _hoisted_2 = { class: "cy-item-count total-count__start" };
const _hoisted_3 = { class: "total-count__end" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'TotalCount',
    setup(__props) {
        // 페이지네이션 좌측 총 수량
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _renderSlot(_ctx.$slots, "default")
                ]),
                _createElementVNode("div", _hoisted_3, [
                    _renderSlot(_ctx.$slots, "end")
                ])
            ]));
        };
    }
});
